import { Box } from '@react-three/drei'

export default function BookshelfMesh({ width, height, depth, position, color, isSelected }) {
    // 本棚の構造: 側板2枚 + 棚板5段

    // 側板: 左右2枚（高さ100%、奥行き100%、薄い板）
    const sideWidth = width * 0.05
    const sideHeight = height
    const sideDepth = depth
    const leftSideX = -width / 2 + sideWidth / 2
    const rightSideX = width / 2 - sideWidth / 2

    // 棚板: 幅100%、薄い板
    const shelfWidth = width
    const shelfHeight = height * 0.03
    const shelfDepth = depth

    // 棚板の位置（5段: 底板、棚板×3、天板）
    const shelfYPositions = [
        position[1] - height / 2 + shelfHeight / 2, // 底板
        position[1] - height / 4, // 棚板1
        position[1], // 棚板2（中央）
        position[1] + height / 4, // 棚板3
        position[1] + height / 2 - shelfHeight / 2, // 天板
    ]

    // 背板: 幅100%、高さ100%、薄い板
    const backWidth = width
    const backHeight = height
    const backDepth = depth * 0.02
    const backZ = -depth / 2 + backDepth / 2

    return (
        <group>
            {/* 左側板 */}
            <Box args={[sideWidth, sideHeight, sideDepth]} position={[leftSideX, position[1], 0]}>
                <meshStandardMaterial
                    color={color}
                    metalness={0.3}
                    roughness={0.4}
                    opacity={isSelected ? 1 : 0.9}
                    transparent
                />
            </Box>

            {/* 右側板 */}
            <Box args={[sideWidth, sideHeight, sideDepth]} position={[rightSideX, position[1], 0]}>
                <meshStandardMaterial
                    color={color}
                    metalness={0.3}
                    roughness={0.4}
                    opacity={isSelected ? 1 : 0.9}
                    transparent
                />
            </Box>

            {/* 棚板（5段） */}
            {shelfYPositions.map((shelfY, index) => (
                <Box key={index} args={[shelfWidth, shelfHeight, shelfDepth]} position={[0, shelfY, 0]}>
                    <meshStandardMaterial
                        color={color}
                        metalness={0.3}
                        roughness={0.4}
                        opacity={isSelected ? 1 : 0.9}
                        transparent
                    />
                </Box>
            ))}

            {/* 背板 */}
            <Box args={[backWidth, backHeight, backDepth]} position={[0, position[1], backZ]}>
                <meshStandardMaterial
                    color={color}
                    metalness={0.3}
                    roughness={0.4}
                    opacity={isSelected ? 1 : 0.9}
                    transparent
                />
            </Box>

            {/* ワイヤーフレーム - 左側板 */}
            <Box args={[sideWidth, sideHeight, sideDepth]} position={[leftSideX, position[1], 0]}>
                <meshBasicMaterial
                    color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'}
                    wireframe
                    opacity={isSelected ? 0.6 : 0.3}
                    transparent
                />
            </Box>

            {/* ワイヤーフレーム - 右側板 */}
            <Box args={[sideWidth, sideHeight, sideDepth]} position={[rightSideX, position[1], 0]}>
                <meshBasicMaterial
                    color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'}
                    wireframe
                    opacity={isSelected ? 0.6 : 0.3}
                    transparent
                />
            </Box>

            {/* ワイヤーフレーム - 棚板（5段） */}
            {shelfYPositions.map((shelfY, index) => (
                <Box key={`wire-${index}`} args={[shelfWidth, shelfHeight, shelfDepth]} position={[0, shelfY, 0]}>
                    <meshBasicMaterial
                        color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'}
                        wireframe
                        opacity={isSelected ? 0.6 : 0.3}
                        transparent
                    />
                </Box>
            ))}

            {/* ワイヤーフレーム - 背板 */}
            <Box args={[backWidth, backHeight, backDepth]} position={[0, position[1], backZ]}>
                <meshBasicMaterial
                    color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'}
                    wireframe
                    opacity={isSelected ? 0.6 : 0.3}
                    transparent
                />
            </Box>

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
